import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/zengdai/Workspace/vimwiki/Projects/Blogger/blogv3/src/components/posts-layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`Starting to refresh my OpenGL brain and figure a good chance to make tool sharp to survive in wild OpenGL Programming... TL;DR `}<a parentName="p" {...{
        "href": "https://github.com/daizeng1984/dotfiles/blob/master/neovim/nvim/my-snippets/UltiSnips/cpp.snippets"
      }}>{`code`}</a></p>
    <h1>{`Why?`}</h1>
    <p>{`I know you should have a framework or some engine anyway. But what if not or you need to do some low level API hack? You probably need to anyway find a toy example to get started.`}</p>
    <p>{`Another point is: graphics API is designed as driver friendly (you can even say unreadable). To do a simple task, you need very strange function combination (e.g. genbuffer, bindbuffer ...) and you need to handle all the states that you probably cannot remember all.`}</p>
    <p>{`So the snippets are the quick resources to go when you run into these cases and they can also be a good tutorial for beginners.`}</p>
    <h1>{`Prerequisites`}</h1>
    <p>{`Install your favorite snippets engine e.g. coc-snippets and point it to your customized snippets like I did `}<a parentName="p" {...{
        "href": "https://github.com/daizeng1984/dotfiles/blob/master/neovim/nvim/my-snippets/UltiSnips/cpp.snippets"
      }}>{`here`}</a>{`. Setting up a working environment can be frustrating. If you work in `}{`*`}{`nix, I got your back. Just install `}<a parentName="p" {...{
        "href": "https://nixos.org/"
      }}>{`Nix`}</a>{` and `}<a parentName="p" {...{
        "href": "https://direnv.net/"
      }}>{`direnv`}</a>{`. Works best for Linux machine though. For more details, see my previous `}<a parentName="p" {...{
        "href": "../2020-12-10-nix-power-2"
      }}>{`post`}</a>{`. BTW, my script even help generate the glad version based on your need. Feel free to make changes to `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`default.nix`}</code>{`.`}</p>
    <h1>{`GL Snippets`}</h1>
    <h2>{`Header`}</h2>
    <p>{`I meant survive in wild but not naked. You need these almost must-have headers. With GLFW, you don't need to worry about GL context binding to native window. With GLAD you care less about OGL function pointers. GLM saves you some scratch work to implement e.g. vec2.`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "cpp"
    }}><pre parentName="div" {...{
        "className": "language-cpp"
      }}><code parentName="pre" {...{
          "className": "language-cpp"
        }}><span parentName="code" {...{
            "className": "token comment"
          }}>{`// Generate your own header https://github.com/Dav1dde/glad/tree/glad2`}</span>{`
`}<span parentName="code" {...{
            "className": "token macro property"
          }}><span parentName="span" {...{
              "className": "token directive-hash"
            }}>{`#`}</span><span parentName="span" {...{
              "className": "token directive keyword"
            }}>{`include`}</span>{` `}<span parentName="span" {...{
              "className": "token string"
            }}>{`<glad/glad.h>`}</span></span>{`
`}<span parentName="code" {...{
            "className": "token macro property"
          }}><span parentName="span" {...{
              "className": "token directive-hash"
            }}>{`#`}</span><span parentName="span" {...{
              "className": "token directive keyword"
            }}>{`define`}</span>{` `}<span parentName="span" {...{
              "className": "token macro-name"
            }}>{`GLFW_INCLUDE_NONE`}</span></span>{`
`}<span parentName="code" {...{
            "className": "token macro property"
          }}><span parentName="span" {...{
              "className": "token directive-hash"
            }}>{`#`}</span><span parentName="span" {...{
              "className": "token directive keyword"
            }}>{`include`}</span>{` `}<span parentName="span" {...{
              "className": "token string"
            }}>{`<GLFW/glfw3.h>`}</span></span>{`
`}<span parentName="code" {...{
            "className": "token macro property"
          }}><span parentName="span" {...{
              "className": "token directive-hash"
            }}>{`#`}</span><span parentName="span" {...{
              "className": "token directive keyword"
            }}>{`include`}</span>{` `}<span parentName="span" {...{
              "className": "token string"
            }}>{`<glm/glm.hpp>`}</span></span>{`
`}<span parentName="code" {...{
            "className": "token macro property"
          }}><span parentName="span" {...{
              "className": "token directive-hash"
            }}>{`#`}</span><span parentName="span" {...{
              "className": "token directive keyword"
            }}>{`define`}</span>{` `}<span parentName="span" {...{
              "className": "token macro-name"
            }}>{`STB_IMAGE_IMPLEMENTATION`}</span></span>{`
`}<span parentName="code" {...{
            "className": "token macro property"
          }}><span parentName="span" {...{
              "className": "token directive-hash"
            }}>{`#`}</span><span parentName="span" {...{
              "className": "token directive keyword"
            }}>{`include`}</span>{` `}<span parentName="span" {...{
              "className": "token string"
            }}>{`<stb_image.h>`}</span></span></code></pre></div>
    <h2>{`Basic Assets`}</h2>
    <h3>{`Geometry`}</h3>
    <p>{`Would you like a triangle?`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "cpp"
    }}><pre parentName="div" {...{
        "className": "language-cpp"
      }}><code parentName="pre" {...{
          "className": "language-cpp"
        }}><span parentName="code" {...{
            "className": "token keyword"
          }}>{`const`}</span>{` GLfloat triangleVertex`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`[`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`]`}</span>{` `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`
   `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`-`}</span><span parentName="code" {...{
            "className": "token number"
          }}>{`1.0f`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`-`}</span><span parentName="code" {...{
            "className": "token number"
          }}>{`1.0f`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` `}<span parentName="code" {...{
            "className": "token number"
          }}>{`0.0f`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{`
   `}<span parentName="code" {...{
            "className": "token number"
          }}>{`1.0f`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`-`}</span><span parentName="code" {...{
            "className": "token number"
          }}>{`1.0f`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` `}<span parentName="code" {...{
            "className": "token number"
          }}>{`0.0f`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{`
   `}<span parentName="code" {...{
            "className": "token number"
          }}>{`0.0f`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{`  `}<span parentName="code" {...{
            "className": "token number"
          }}>{`1.0f`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` `}<span parentName="code" {...{
            "className": "token number"
          }}>{`0.0f`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{`
`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span></code></pre></div>
    <p>{`Cube, and teapot are also in snippets, but a bit wordy to show here.`}</p>
    <h3>{`Shader`}</h3>
    <p>{`For exmaple, to quickly grab a working embedded shader is very handy if you just wanted to draw A SINGLE TRIANGLE!`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "cpp"
    }}><pre parentName="div" {...{
        "className": "language-cpp"
      }}><code parentName="pre" {...{
          "className": "language-cpp"
        }}><span parentName="code" {...{
            "className": "token keyword"
          }}>{`const`}</span>{` `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`char`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`*`}</span>{` vertexShader `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{`
`}<span parentName="code" {...{
            "className": "token string"
          }}>{`"#version \${1:400}\\n"`}</span>{`
`}<span parentName="code" {...{
            "className": "token string"
          }}>{`"in vec3 vp;"`}</span>{`
`}<span parentName="code" {...{
            "className": "token string"
          }}>{`"void main() {"`}</span>{`
`}<span parentName="code" {...{
            "className": "token string"
          }}>{`"  gl_Position = vec4(vp, 1.0);"`}</span>{`
`}<span parentName="code" {...{
            "className": "token string"
          }}>{`"}"`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span></code></pre></div>
    <p>{`and of course there are fragment shader as well.`}</p>
    <h2>{`Push/Pop States`}</h2>
    <p>{`API leaves for you to manage all states, my dear. Let's finish it with one blow by enumerating all states possible. Cause you never know which state is giving you black screen 🤦. It's rocket launcher solution: no time for these little hide & see games😆!`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "cpp"
    }}><pre parentName="div" {...{
        "className": "language-cpp"
      }}><code parentName="pre" {...{
          "className": "language-cpp"
        }}>{`GLint last_program`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{` `}<span parentName="code" {...{
            "className": "token function"
          }}>{`glGetIntegerv`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`GL_CURRENT_PROGRAM`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`&`}</span>{`last_program`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{`
GLint last_texture`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{` `}<span parentName="code" {...{
            "className": "token function"
          }}>{`glGetIntegerv`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`GL_TEXTURE_BINDING_2D`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`&`}</span>{`last_texture`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{`
GLint last_array_buffer`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{` `}<span parentName="code" {...{
            "className": "token function"
          }}>{`glGetIntegerv`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`GL_ARRAY_BUFFER_BINDING`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`&`}</span>{`last_array_buffer`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{`
GLint last_element_array_buffer`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{` `}<span parentName="code" {...{
            "className": "token function"
          }}>{`glGetIntegerv`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`GL_ELEMENT_ARRAY_BUFFER_BINDING`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`&`}</span>{`last_element_array_buffer`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{`
GLint last_vertex_array`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{` `}<span parentName="code" {...{
            "className": "token function"
          }}>{`glGetIntegerv`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`GL_VERTEX_ARRAY_BINDING`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`&`}</span>{`last_vertex_array`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{`
GLint last_blend_src`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{` `}<span parentName="code" {...{
            "className": "token function"
          }}>{`glGetIntegerv`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`GL_BLEND_SRC`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`&`}</span>{`last_blend_src`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{`
GLint last_blend_dst`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{` `}<span parentName="code" {...{
            "className": "token function"
          }}>{`glGetIntegerv`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`GL_BLEND_DST`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`&`}</span>{`last_blend_dst`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{`
GLint last_blend_equation_rgb`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{` `}<span parentName="code" {...{
            "className": "token function"
          }}>{`glGetIntegerv`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`GL_BLEND_EQUATION_RGB`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`&`}</span>{`last_blend_equation_rgb`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{`
GLint last_blend_equation_alpha`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{` `}<span parentName="code" {...{
            "className": "token function"
          }}>{`glGetIntegerv`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`GL_BLEND_EQUATION_ALPHA`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`&`}</span>{`last_blend_equation_alpha`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{`
GLint last_viewport`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`[`}</span><span parentName="code" {...{
            "className": "token number"
          }}>{`4`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`]`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{` `}<span parentName="code" {...{
            "className": "token function"
          }}>{`glGetIntegerv`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`GL_VIEWPORT`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` last_viewport`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{`
GLboolean last_enable_blend `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token function"
          }}>{`glIsEnabled`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`GL_BLEND`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{`
GLboolean last_enable_cull_face `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token function"
          }}>{`glIsEnabled`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`GL_CULL_FACE`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{`
GLboolean last_enable_depth_test `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token function"
          }}>{`glIsEnabled`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`GL_DEPTH_TEST`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{`
GLboolean last_enable_scissor_test `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token function"
          }}>{`glIsEnabled`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`GL_SCISSOR_TEST`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span></code></pre></div>
    <h2>{`*`}{`*`}{`O`}</h2>
    <p>{`VBO, VAO, EBO, FBO API is unhuman. But here a simple explanation: VBO is just buffer to store vertex, FBO is buffer to store pixels, while VAO is wrapper to manage VBO. Basically they are a bunch of gen and bind functions. Just checkout e.g. `}<a parentName="p" {...{
        "href": "https://github.com/daizeng1984/dotfiles/blob/8684261b1a01835758ec3cb9179587ef7a1ef7d6/neovim/nvim/my-snippets/UltiSnips/cpp.snippets#L92-L117"
      }}>{`snippets`}</a>{`.`}</p>
    <h2>{`Image & Texture`}</h2>
    <p>{`To test a simple image...`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "cpp"
    }}><pre parentName="div" {...{
        "className": "language-cpp"
      }}><code parentName="pre" {...{
          "className": "language-cpp"
        }}><span parentName="code" {...{
            "className": "token keyword"
          }}>{`int`}</span>{` width`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` height`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` channel`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{`
`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`unsigned`}</span>{` `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`char`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`*`}</span>{` image `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token function"
          }}>{`stbi_load`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`"image.png"`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`&`}</span>{`width`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`&`}</span>{`height`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`&`}</span>{`channel`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` STBI_rgb`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{` `}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// or STBI_rgb_alpha`}</span>{`

`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`if`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`image `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`==`}</span>{` `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`nullptr`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{`
    std`}<span parentName="code" {...{
            "className": "token double-colon punctuation"
          }}>{`::`}</span>{`cout `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`<<`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`"Cannot load image"`}</span>{` `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`<<`}</span>{` std`}<span parentName="code" {...{
            "className": "token double-colon punctuation"
          }}>{`::`}</span>{`endl`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{`

`}<span parentName="code" {...{
            "className": "token function"
          }}>{`glGenTextures`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token number"
          }}>{`1`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`&`}</span>{`textureId`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{`
`}<span parentName="code" {...{
            "className": "token function"
          }}>{`glBindTexture`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`GL_TEXTURE_2D`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` textureId`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{`

`}<span parentName="code" {...{
            "className": "token function"
          }}>{`glTexParameteri`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{` GL_TEXTURE_2D`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` GL_TEXTURE_WRAP_S`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` GL_CLAMP_TO_EDGE `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{`
`}<span parentName="code" {...{
            "className": "token function"
          }}>{`glTexParameteri`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{` GL_TEXTURE_2D`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` GL_TEXTURE_WRAP_T`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` GL_CLAMP_TO_EDGE `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{`
`}<span parentName="code" {...{
            "className": "token function"
          }}>{`glTexParameteri`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`GL_TEXTURE_2D`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` GL_TEXTURE_MIN_FILTER`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` GL_LINEAR`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{` `}<span parentName="code" {...{
            "className": "token comment"
          }}>{`//GL_LINEAR_MIPMAP_LINEAR `}</span>{`
`}<span parentName="code" {...{
            "className": "token function"
          }}>{`glTexParameteri`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`GL_TEXTURE_2D`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` GL_TEXTURE_MAG_FILTER`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` GL_LINEAR`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{`

`}<span parentName="code" {...{
            "className": "token function"
          }}>{`glTexImage2D`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`GL_TEXTURE_2D`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` `}<span parentName="code" {...{
            "className": "token number"
          }}>{`0`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` channel `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`==`}</span>{` `}<span parentName="code" {...{
            "className": "token number"
          }}>{`3`}</span>{` `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`?`}</span>{` GL_RGB `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span>{` GL_RBGA`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` w`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` h`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` `}<span parentName="code" {...{
            "className": "token number"
          }}>{`0`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` channel `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`==`}</span>{` `}<span parentName="code" {...{
            "className": "token number"
          }}>{`3`}</span>{` `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`?`}</span>{` GL_RGB `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span>{` GL_RBGA`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` GL_UNSIGNED_BYTE`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` image`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{`
`}<span parentName="code" {...{
            "className": "token comment"
          }}>{`//glGenerateMipmap( GL_TEXTURE_2D); // generate mipmap if we use that`}</span>{`

`}<span parentName="code" {...{
            "className": "token function"
          }}>{`glBindTexture`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`GL_TEXTURE_2D`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` `}<span parentName="code" {...{
            "className": "token number"
          }}>{`0`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{`
`}<span parentName="code" {...{
            "className": "token function"
          }}>{`stbi_image_free`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`image`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span></code></pre></div>
    <h2>{`MVP`}</h2>
    <p>{`Model View Projection refresher`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "cpp"
    }}><pre parentName="div" {...{
        "className": "language-cpp"
      }}><code parentName="pre" {...{
          "className": "language-cpp"
        }}>{`glm`}<span parentName="code" {...{
            "className": "token double-colon punctuation"
          }}>{`::`}</span>{`mat4 Projection `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` glm`}<span parentName="code" {...{
            "className": "token double-colon punctuation"
          }}>{`::`}</span><span parentName="code" {...{
            "className": "token function"
          }}>{`perspective`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`glm`}<span parentName="code" {...{
            "className": "token double-colon punctuation"
          }}>{`::`}</span><span parentName="code" {...{
            "className": "token function"
          }}>{`radians`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`fovdegree`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` aspectRatio`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` near`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` far`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{`
`}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// Or, for an ortho camera :`}</span>{`
`}<span parentName="code" {...{
            "className": "token comment"
          }}>{`//glm::mat4 Projection = glm::ortho(x0, x1, y0, y1, z0, z1); // In world coordinates`}</span>{`
  
`}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// View`}</span>{`
glm`}<span parentName="code" {...{
            "className": "token double-colon punctuation"
          }}>{`::`}</span>{`mat4 View `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` glm`}<span parentName="code" {...{
            "className": "token double-colon punctuation"
          }}>{`::`}</span><span parentName="code" {...{
            "className": "token function"
          }}>{`lookAt`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`
    glm`}<span parentName="code" {...{
            "className": "token double-colon punctuation"
          }}>{`::`}</span><span parentName="code" {...{
            "className": "token function"
          }}>{`vec3`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token number"
          }}>{`0`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span><span parentName="code" {...{
            "className": "token number"
          }}>{`0`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`-`}</span><span parentName="code" {...{
            "className": "token number"
          }}>{`1`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` `}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// Camera`}</span>{`
    glm`}<span parentName="code" {...{
            "className": "token double-colon punctuation"
          }}>{`::`}</span><span parentName="code" {...{
            "className": "token function"
          }}>{`vec3`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token number"
          }}>{`0`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span><span parentName="code" {...{
            "className": "token number"
          }}>{`0`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span><span parentName="code" {...{
            "className": "token number"
          }}>{`0`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` `}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// Lookat`}</span>{`
    glm`}<span parentName="code" {...{
            "className": "token double-colon punctuation"
          }}>{`::`}</span><span parentName="code" {...{
            "className": "token function"
          }}>{`vec3`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token number"
          }}>{`0`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span><span parentName="code" {...{
            "className": "token number"
          }}>{`1`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span><span parentName="code" {...{
            "className": "token number"
          }}>{`0`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{`  `}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// Up`}</span>{`
    `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{`
  
`}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// Model`}</span>{`
glm`}<span parentName="code" {...{
            "className": "token double-colon punctuation"
          }}>{`::`}</span>{`mat4 Model `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` glm`}<span parentName="code" {...{
            "className": "token double-colon punctuation"
          }}>{`::`}</span><span parentName="code" {...{
            "className": "token function"
          }}>{`mat4`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token number"
          }}>{`1.0f`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{`
`}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// MVP`}</span>{`
glm`}<span parentName="code" {...{
            "className": "token double-colon punctuation"
          }}>{`::`}</span>{`mat4 mvp `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` Projection `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`*`}</span>{` View `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`*`}</span>{` Model`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span></code></pre></div>
    <h1>{`Test Our Snippets`}</h1>
    <h2>{`Case 1`}</h2>
    <p>{`To draw a triangle to see if opengl snippet works. First `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`glheader`}</code>{` to include everthting and then get some globals with shader `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`glsimplevsfs`}</code>{`, and geometry `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`gltriangle`}</code>{`. Then create main function body with `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`glhellworld`}</code>{` and fill the intialization code with `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`glvbo`}</code>{`, then `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`glvao`}</code>{` and then in the main loop do `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`gldraw`}</code>{`. Totally time spent ~1 min if most variables are kept.`}</p>
    <h2>{`Case 2`}</h2>
    <p>{`TODO`}</p>
    <h1>{`Vulkan Snippets`}</h1>
    <p>{`Ok, OpenGL is not that bad. Let's crack Vulkan next time!`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      